<template>
  <div class="modal_wrapper active">
    <div class="modal_window white_box create_report_modal">
      <button
        class="close_modal close_btn"
        @click="close()"
      >
        <svg
          fill="none"
          height="32"
          viewBox="0 0 32 32"
          width="32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 7L7 25"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            d="M25 25L7 7"
            stroke="#040707"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </svg>
      </button>

      <h3 class="heading_h4 font_bold mb_16">
        Reorder report pages
      </h3>
      <div class="p_small mb_16">
        Use the arrows to move your pages into the order you want, then click update
      </div>
      <table
        v-if="!updating"
        class="pages_table p_small"
      >
        <thead>
          <tr>
            <th class="page-column">
              <span>Page</span>
            </th>
            <th class="button-column">
              <span>Move down</span>
            </th>
            <th class="button-column">
              <span>Move up</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="page in tempPages"
            :key="page.id"
          >
            <td>
              <div class="page-info">
                <strong>Page {{ page.position }}</strong>{{ pageTableWording(page) }}
              </div>
            </td>
            <td>
              <div class="button_wrapper">
                <button
                  v-if="page.newPosition <= pages.length-1"
                  class="move-page"
                  style="color: black;"
                  @click="movePage('down', page)"
                >
                  <i class="fas fa-arrow-down" />
                </button>
              </div>
            </td>
            <td>
              <div class="button_wrapper">
                <button
                  v-if="page.newPosition > 1"
                  class="move-page"
                  style="color: black;"
                  @click="movePage('up', page)"
                >
                  <i class="fas fa-arrow-up" />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <h3
        v-if="updating"
        class="heading_h4 font_bold mb_16 updating"
      >
        Updating...
      </h3>

      <div
        v-if="!updating"
        class="flex items-center section_modal_footer"
      >
        <button
          class="btn btn_md secondary_btn close_modal ml_auto mr_8"
          @click="close()"
        >
          <span>Cancel</span>
        </button>
        <button
          class="btn btn_md primary_btn"
          @click="save()"
        >
          <span>Update</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import _ from 'lodash';

export default {
  data() {
    return {
      tempPages: [],
      updating: false,
    }
  },
  computed: {
    ...mapState('report', ['report']),
    ...mapState('pages', ['pages']),
    ...mapState(['widgetModal'])
  },
  mounted() {
    this.tempPages = this.pages;
    _.each(this.tempPages, (page) => {
      page.newPosition = page.position;
    });
  },
  methods: {
    ...mapActions({
      savePagesRequest: 'pages/savePagesRequest',
      refreshPages: 'pages/getReportPages',
      close: 'widgetModal/closeModal'
    }),
    movePage(direction, page) {
      const currentPos = parseInt(page.newPosition);
      const newPos = (direction === 'up' ? currentPos - 1 : currentPos + 1);
      const currentPageIndex = _.findIndex(this.tempPages, {newPosition: currentPos});
      const replacePageIndex = _.findIndex(this.tempPages, {newPosition: newPos});

      this.tempPages[currentPageIndex].newPosition = newPos;
      this.tempPages[replacePageIndex].newPosition = currentPos;

      this.tempPages = _.orderBy(this.tempPages, ['newPosition'], ['asc']);
    },
    pageTableWording(page) {
      let string = ``;
      if (page.layout.length) {
        string += ` - (`;
        _.each(page.layout, (widget, index) => {
          if ((index + 1) === page.layout.length) {
            string += `${widget.name}`;
          } else {
            string += `${widget.name}, `;
          }
        });
        string += `)`;
      } else {
        string += ` - (No widgets)`;
      }
      return string;
    },
    async save() {
      this.updating = true;
      _.each(this.tempPages, (page) => {
        page.position = page.newPosition;
        delete page.newPosition;
      });
      await this.savePagesRequest(this.tempPages);
      this.close();
      this.refreshPages({type: this.report.is_template ? 'templates' : 'reports', id: this.report.id})
    }
  },
}
</script>

<style scoped src="../../../../reports/css/modal.css" />

<style scoped>
.pages_table {
  table-layout: fixed;
  overflow-x: auto;
  word-wrap: break-word;
  width: 100%;
}

.page-column {
  width: 70%;
}

.button-column {
  width: 15%;
  text-align: center;
}

.pages_table thead th {
  padding: 2rem 1rem 1rem;
}

.pages_table thead th span {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  letter-spacing: -0.25px;
  margin-right: 0.25rem;
}

.pages_table tbody tr:nth-of-type(2n+1) {
  background: #FBFAFA;
}

.pages_table tbody tr td {
  padding: 1rem;
}

.button_wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-info {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.updating {
  text-align: center;
}
</style>
